import { createFileRoute } from '@tanstack/react-router';

import { Indicators } from '@/view/pages/Indicators';

export const Route = createFileRoute('/_protected/$programId/indicadores')({
  component: Indicators,
  context: (context): { title: string } => ({
    ...context,
    title: 'Indicadores',
  }),
});
